import { post } from "../request";

export const uploadLog = (data) => {
  return post("/ProxyAdmin/log/save", data);
};
